// Values match the backend TherapyType enum names exactly
export enum TherapyType {
  Individual = 'Individual',
  Partner = 'Partner',
  Family = 'Family',
  SameDay = 'SameDay',
  Psychiatry = 'Psychiatry'
}

export const therapyTypes = [
  TherapyType.Individual,
  TherapyType.Partner,
  TherapyType.Family,
  TherapyType.SameDay
] as const;

export const isTherapyType = (value: string): value is TherapyType =>
  (Object.values(TherapyType) as string[]).includes(value);

export const MAX_GROUP_INVITATIONS_DEFAULT = 6;
export const MAX_GROUP_INVITATIONS_BY_TYPE: Partial<
  Record<TherapyType, number>
> = {
  [TherapyType.Partner]: 1
};
